module.exports = __webpack_public_path__ + "media/pages/foodbank-6b09b503.jpg";